import React from 'react';
import '../css/footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedin,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="social-icons">
          <a href="https://www.linkedin.com/company/jr-ai-consulting" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a href="https://wa.me/+33672260278" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
          
        </div>
        <p>{`JR-AI-Consulting © 2024-${currentYear}. All rights reserved. Developed by JR-AI-Consulting`}</p>
      </div>
    </footer>
  );
}

export default Footer;
